<div class="searchbar-whereapp">
    <div id="insert-controls-div">
        <button mat-flat-button class="insert-button" (click)="newAreaByGeometry()">
            <mat-icon [inline]="true">add</mat-icon>
            Inserisci da Mappa
        </button>
        <button mat-flat-button class="insert-button" (click)="newAreaByGeojson()">
            <mat-icon [inline]="true">add</mat-icon>
            Inserisci da GeoJSON
        </button>
    </div>
    <div id="search-div">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <input spellcheck="false" type="text" #filter [(ngModel)]="filterValue" placeholder="Filtra per parole chiave" 
          (keydown)="onSearchKeydown($event)">
        <i class="fa fa-times" aria-hidden="true" (click)="onFilterClear();onFiltering()"></i>
        <button mat-stroked-button (click)="onFiltering()" class="ml-2" [disabled]="filterValue.length < 4 && filterValue.length > 0">Cerca</button>
      </div>
    <!-- <div id="pagination-div">
        <mat-paginator [hidePageSize]="true" [pageSize]="50" [showFirstLastButtons]="true">
        </mat-paginator>
    </div> -->
</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div class="empty-list" *ngIf="emptyList">
    <span>Non è presente ancora nessuna Area, creane una adesso.</span>
</div>

<div id="main-container">
    <!-- Tabella aree -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
        <!-- Name -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef fxFlex="90%" fxFlex.sm="90%" fxFlex.xs="90%" class="mobile-large"
                mat-sort-header>
                Nome </mat-header-cell>
            <mat-cell *matCellDef="let area" fxFlex="90%" fxFlex.sm="90%" fxFlex.xs="90%" class="mobile-large">
                {{ area.areaName }}
            </mat-cell>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="mobile-large">
            </mat-header-cell>
            <mat-cell *matCellDef="let area" fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%">
                <button type="button" mat-stroked-button matTooltip="Mostra Mappa"
                    [matTooltipShowDelay]="600" (click)="onMapPreview(area)">
                    <mat-icon fontSet="material-icons" style="color: grey;">map</mat-icon>
                </button>
                <!-- <button type="button" mat-stroked-button matTooltip="Operazione proibita."
                    [matTooltipShowDelay]="600" color="warn" style="margin-left: 10px;"
                    (click)="onSenderDelete(sender)" [disabled]="true">
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-cell>
        </ng-container>

        <!-- Impostazione di righe e colonne -->
        <mat-header-row *matHeaderRowDef=" displayedColumns; sticky: true" style="height: 64px">
        </mat-header-row>

        <mat-row class="element-row" *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row>
        <!-- <mat-row class="temp-element-row" *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row> -->

    </mat-table>
</div>

<div class="loading" *ngIf="sub === true">
</div>